import * as React from 'react';
import { useState, useEffect } from 'react';
import { Controller, useForm } from "react-hook-form";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Divider } from '@mui/material';
import FormControl from '@mui/material/FormControl';


import { TextTypeInput } from './TextTypeInput';
import { DocumentFileUpload } from './DocumentFileUpload'
export const AwardsDialog = ({
    awards,
    setAwards,
    setOpenDialog,
    index,
    isEditing=false

}) => {

    const [open, setOpen] = useState(false);
    const {
        control,
        handleSubmit,
        formState: { errors, isValid, isDirty },
        getValues,
        setValue,
        reset
    } = useForm();

    const handleClickOpen = () => {
        const awardsData = awards?.[index];
        reset({
            name: awardsData?.name || '',
            uploadedImages: awardsData?.uploadedImages || ''
          });
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setOpenDialog?.setOpenDialog(false);
        reset();
    };

    const handleSubmitForm = (field) => {
        const data = getValues();
        setOpen(false);
        if (isEditing) {
            setAwards(awards.map((item, i) => i === index ? { ...item, ...data } : item));
        }

        if (!isEditing && !(data.name === "" || data.name === null || data.name === undefined)) {
            setAwards([...awards, data]);
        }
        reset();
    };

    return (
        <React.Fragment>
            {
                !isEditing ? (
                    <button className=" flex p-2 border rounded-lg border-blue-500 text-sm text-semibold text-blue-700 gap-1 " onClick={handleClickOpen}>
                        <img src="https://views.medibuddy.in/providerUi/assets/bluePlus.svg" alt="" />
                        <p> Add New</p>
                    </button>
                ) :
                    <img src="https://views.medibuddy.in/providerUi/assets/editIcon.svg" alt="Edit" onClick={(e) => { e.preventDefault(); handleClickOpen() }} style={{ cursor: 'pointer' }} />
            }
        

            <Dialog
                style={{ borderRadius: '16px' }}
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'sm'}
                PaperProps={{
                    component: 'form',
                    style: { borderRadius: '1rem' },
                    onSubmit: (event) => {
                        event.preventDefault();
                        handleClose();
                    },
                }}
            >
                <DialogTitle>
                    <div className="text-xl font-semibold text-left text-[#47566A]">
                    Awards & Recognition
                    </div>

                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <div className="flex flex-col " style={{ gap: '1.5rem' }}>
                            <div className="flex flex-col ">
                                <div className="flex  text-base font-normal text-[#47566A] pb-1" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                Award Name
                                    <p className=' text-mb-red' >*</p>
                                </div>
                                <div className="flex flex-row" style={{ gap: '1.5rem' }}>
                                <FormControl error={!!errors.name}>
                                    <TextTypeInput
                                    name={'name'}
                                    multiline
                                    placeholder="Enter name of the award "
                                    control={control}
                                    defaultValue={''}
                                    width={'31.6rem'}
                                    height={'4.25rem'}
                                    rules={{ required: "Mandatory field" }}
                                    errors={errors}
                                />
                                    </FormControl>
                                </div>
                            </div>

                      

                            <div className=" flex flex-col gap-1">
                                <div className="flex  text-base font-normal text-[#47566A]" style={{ width: '20vw', justifyContent: 'flex-start', }}>
                                    Upload Award File
                                </div>

                                <div className="flex flex-row basis-3 gap-2">
                                    <Controller
                                        name={'uploadedImages'}
                                        control={control}
                                        render={({ field }) => {
                                            return (
                                                <DocumentFileUpload field={field} setValue={setValue} name={'uploadedImages'} />
                                            )
                                        }} />

                                </div>
                            </div>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <Divider variant='fullWidth' />

                <DialogActions>
                    <div className="flex gap-2 px-3 py-2">
                        <Button className=' border rounded-lg  text-sm text-semibold p-1  gap-1 ' variant='outlined' onClick={handleClose} style={{ color: '#252D38', borderColor: '#DBE0E6', borderRadius: '0.5rem' }}>Cancel</Button>
                        <button
                            className={`${ isDirty ? ' border-blue-700 text-white bg-blue-600 ' : ' bg-[#F5F7F8] border-[#DBE0E6] '} "flex flex-col justify-center py-2 px-4 border rounded-lg "`}
                            style={{ color: isDirty ? 'white' : '#A4B0C0' }}
                            onClick={handleSubmit(handleSubmitForm)}                            >
                            Save Details
                        </button>  
                    </div>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}